<template>
  <div class="mainContent">
    <slot
      :response="response"
      :loading="loading"
      :fetchError="fetchError"
    />
  </div>
</template>

<script>
  // require modules
  /* eslint-disable no-unused-vars */
  const _ = require('lodash');
  let host = require('../js/const').host;
  const apikey = require('../js/const').apikey;

export default {
  name: 'FetchProtein',
  props: ['protein'],
  data() {
    return {
      response: null,
      loading: false,
      fetchError:'',
      isDev: process.env.NODE_ENV === 'development',
    };
  },
  computed: {
    jwt: function () {
      return this.$store.getters['User/jwt'];
    },
  },
  mounted() {
    const vm = this;
    // /* eslint-disable no-console */

    vm.getItems();
  },
  methods: {
    async getItems() {
        const vm = this

        // /* eslint-disable no-console */
      

        vm.loading = true

        if(vm.isDev) {
          host = require('../js/const').devHost;
        }

        let url = `${host}/proteins/${vm.protein}`;

        if (vm.protein && !_.isEmpty(vm.protein)) {
          try{
          const res = await fetch(url, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
              Authorization: `Bearer ${apikey}`
            }
          })
        
          if(!res.ok && res.status >= 400 && res.status <= 499){
            vm.loading = false;
            vm.response = ''
            vm.fetchError = `${res.status} ${res.statusText}`
            return;
          }
          if (!res.ok && res.status >= 500 && res.status <= 599) {
          vm.loading = false;
          vm.response = '';
          vm.fetchError = `${res.status} Internal Server Error. Please try again after some time.`;
          return;
        }
          vm.fetchError= '';
          const response = await res.json();
          
             setTimeout(() => {
              vm.loading = false;
              vm.response = response;
             
            }, 10);
        
          }catch(err){
            vm.loading = false;
            vm.response = ''
            vm.fetchError = `${err.message} Internal Server Error. Please try again after some time.`
          }
          
      } else {
        vm.loading = false;
        vm.response = ''
      }
    },
  },
};
</script>

<style scoped>
    .mainContent {
        padding: 20px;
    }
</style>